import { defineType } from "sanity";

export default defineType({
  type: "object",
  name: "faqSection",
  title: "FAQ Section",
  preview: {
    prepare() {
      return { title: "FAQ Section" };
    }
  },
  fields: [
    {
      name: "intro",
      title: "Section Intro",
      type: "sectionIntro"
    },
    {
      name: "questions",
      title: "Questions",
      type: "array",
      of: [{ type: "faqQuestion" }]
    }
  ]
});
